import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NetworkConnectivityService } from 'src/app/core/services/network-connectivity/network-connectivity.service';
import { ScreenService } from 'src/app/core/services/responsive/screen.service';

@Component({
  selector: 'app-no-internet-connection-alert',
  standalone: true,
  imports: [],
  templateUrl: './no-internet-connection-alert.component.html',
  styleUrl: './no-internet-connection-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoInternetConnectionAlertComponent {
  protected readonly screenService = inject(ScreenService);
  protected readonly network = inject(NetworkConnectivityService);
}
